"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _BaseVector = _interopRequireDefault(require("./BaseVector.js"));

var _VectorLayer = _interopRequireDefault(require("../renderer/canvas/VectorLayer.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");

    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
/**
 * @module ol/layer/Vector
 */


/**
 * @classdesc
 * Vector data is rendered client-side, as vectors. This layer type provides most accurate rendering
 * even during animations. Points and labels stay upright on rotated views. For very large
 * amounts of vector data, performance may suffer during pan and zoom animations. In this case,
 * try {@link module:ol/layer/VectorImage~VectorImageLayer}.
 *
 * Note that any property set in the options is set as a {@link module:ol/Object~BaseObject}
 * property on the layer object; for example, setting `title: 'My Title'` in the
 * options means that `title` is observable, and has get/set accessors.
 *
 * @template {import("../source/Vector.js").default} VectorSourceType
 * @extends {BaseVectorLayer<VectorSourceType, CanvasVectorLayerRenderer>}
 * @api
 */
var VectorLayer =
/** @class */
function (_super) {
  __extends(VectorLayer, _super);
  /**
   * @param {import("./BaseVector.js").Options<VectorSourceType>} [opt_options] Options.
   */


  function VectorLayer(opt_options) {
    return _super.call(this, opt_options) || this;
  }

  VectorLayer.prototype.createRenderer = function () {
    return new _VectorLayer["default"](this);
  };

  return VectorLayer;
}(_BaseVector["default"]);

var _default = VectorLayer;
exports["default"] = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUdBOztBQUNBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBSkE7Ozs7O0FBTUE7Ozs7Ozs7Ozs7Ozs7OztBQWVBO0FBQUE7QUFBQTtFQUEwQkE7RUFDeEI7Ozs7O0VBR0EscUJBQVlDLFdBQVosRUFBdUI7V0FDckJDLGtCQUFNRCxXQUFOLEtBQWtCO0VBQ25COztFQUVERTtJQUNFLE9BQU8sSUFBSUMsdUJBQUosQ0FBOEIsSUFBOUIsQ0FBUDtFQUNELENBRkQ7O0VBR0Y7QUFBQyxDQVhELENBQTBCQyxzQkFBMUI7O2VBYWVGLFciLCJuYW1lcyI6WyJfX2V4dGVuZHMiLCJvcHRfb3B0aW9ucyIsIl9zdXBlciIsIlZlY3RvckxheWVyIiwiQ2FudmFzVmVjdG9yTGF5ZXJSZW5kZXJlciIsIkJhc2VWZWN0b3JMYXllciJdLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvbGF5ZXIvVmVjdG9yLmpzIl0sInNvdXJjZXNDb250ZW50IjpbbnVsbF19